import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { contentWidths } from '@/constants/brandingThemes';
import backgroundImage from '@/images/auth-background-layout.png';

export default function UnauthenticatedLayout() {
  return (
    <Box
      sx={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          padding: '30px 10px',
          maxWidth: contentWidths.small,
          margin: '0 auto',
        }}>
        <Outlet />
      </Box>
    </Box>
  );
}
